

export function getFileExtension(file) {
	const filename = file.name;
	if(!filename || filename.lastIndexOf('.') === -1) {
		return 'null'; // No extension found
	}
	return filename.substring(filename.lastIndexOf('.') + 1).toLowerCase();
}


export function getFileType(file) {

	if (file.type) return file.type;

	// Fallback by extension
	const ext = getFileExtension(file);
	switch (ext) {
		case '3dm': return 'model/3dm';
		case 'obj': return 'text/plain';
		case 'stl': return 'model/stl';
		default: return 'application/octet-stream'; // generic binary
	}
}